import { store } from "../store.js"
import axios from "../plugins/axios.js"
import { Message } from "element-ui";
import { createFormData, safeParse } from "../utils.js";

store.registerModule('$main', {
    namespaced: true,
    state: {
        now: Date.now(),
        nodes: [
            ["10.1 12:00", "开始报名"],
            ["10.2 12:00", "探路阶段"],
            ["10.4 12:00", "优化阶段"],
            ["10.6 12:00", "冲刺阶段"],
            ["10.6 24:00", "比赛结束"],
        ],
        hasSignUp: false,
        rankData: [],
        teamId: -1,
        score: 0,
        role: "",
        teamName: "",
        inviteCode: "",
        teammate: null,
    },
    mutations: {
        countDown(state) {
            state.now = Date.now();
        },
        signUp(state, { teamId, role, teamName, inviteCode, teammate, score }) {
            state.hasSignUp = true;
            state.teamId = teamId;
            state.role = (role == 1 ? "leader" : "member");
            state.teamName = teamName;
            state.inviteCode = inviteCode;
            state.teammate = teammate;
            state.score = score;
        },
        quit(state) {
            state.hasSignUp = false;
            state.teamId = -1;
            state.role = "";
            state.teamName = "";
            state.inviteCode = "";
            state.teammate = null;
            state.score = 0;
        },
        removeTeammate(state) {
            state.teammate = true;
        },
        updateRankData(state, { rankData }) {
            state.rankData = rankData;
        }
    },
    getters: {
        nodeNow(state) {
            for (let i = 0; i < state.nodes.length; i++) {
                if (safeParse("2020."+state.nodes[i][0]+" GMT+0800") > state.now) {
                    return i-1;
                }
            }
            return state.nodes.length-1;
        },
        next(state, getters) {
            if (getters.nodeNow == state.nodes.length-1) return -1;
            return Math.floor((safeParse("2020."+state.nodes[getters.nodeNow+1][0])-state.now) / 1000);
        },
        rankData(state, getters) {
            if (getters.nodeNow == 0) {
                return state.rankData;
            } else {
                return state.rankData.sort((a, b) => b.point - a.point);
            }
        },
    },
    actions: {
        async createTeam({ commit, dispatch }, { teamName }) {
            await axios.post("signup.php", createFormData({
                type: "create", teamName
            }))
                .then(({ data: { code, teamId, inviteCode } }) => {
                    if (code == 0) {
                        Message.success("创建队伍成功");
                        commit("signUp", { teamId, role: "leader", teamName, inviteCode });
                        dispatch("getRankList");
                    } else if (code == -1) {
                        Message.error("尚未登录");
                    } else {
                        Message.error("创建队伍出错");
                    }
                })
        },
        async joinTeam({ commit, dispatch }, { inviteCode }) {
            await axios.post("signup.php", createFormData({
                type: "join", inviteCode
            }))
                .then(({ data: { code, teamId, teamName, teammate }}) => {
                    if (code == 0) {
                        Message.success("成功加入队伍");
                        commit("signUp", { teamId, role: "member", teamName, teammate });
                        dispatch("getRankList");
                    } else if (code == -1) {
                        Message.error("尚未登录");
                    } else {
                        Message.error("加入队伍失败");
                    }
                });
        },
        async quitTeam({ commit, dispatch }) {
            await axios.post("signup.php", createFormData({
                type: "quit"
            }))
                .then(({ data: { code }}) => {
                    if (code == 0) {
                        Message.success("成功退出队伍");
                        commit("quit");
                        dispatch("getRankList");
                    } else if (code == -1) {
                        Message.error("尚未登录");
                    } else {
                        Message.error("您没有加入队伍");
                    }
                });
        },
        getRankList({ commit }) {
            axios.get("https://h5mota.com/competition/another1/teams.php")
                .then(({ data }) => {
                    commit("updateRankData", data);
                })
        },
        fetchTeamInfo({ commit }) {
            axios.get("https://h5mota.com/competition/another1/teamInfo.php")
                .then(({ data: { code, team } }) => {
                    if (code == 0) {
                        commit("signUp", team);
                    }
                })
        },
        removeTeammate({ commit }) {
            axios.post("signup.php", createFormData({
                type: "removeTeammate"
            }))
                .then(({ data: { code }}) => {
                    if (code == 0) {
                        Message.success("成功移除队友");
                        commit("removeTeammate");
                    } else if (code == -1) {
                        Message.error("尚未登录");
                    } else {
                        Message.error("您没有加入队伍/没有队友");
                    }
                });
        },
    }
})

if (process.env.NODE_ENV == "production") {
    setInterval(() => {
        store.commit("$main/countDown");
    }, 1000);
    store.dispatch("$main/getRankList");
    store.dispatch("$main/fetchTeamInfo");
} else {
    window.setTime = (time) => store.state.$main.now = time;
}

window.tryJoin = async (inviteCode) => {
    if (!store.state.hasLogin) {
        await store.dispatch("openLoginDialog");
    }
    setTimeout(() => {
        if (store.state.hasLogin) {
            store.dispatch("$main/joinTeam", { inviteCode });
        }
    }, 10);
}; 